import { schema } from "normalizr";

export const organization = new schema.Entity(
  "organization",
  {},
  {
    idAttribute: "organizationId",
  },
);

export const workspace = new schema.Entity(
  "workspace",
  {},
  {
    idAttribute: "workspaceId",
  },
);

export const user = new schema.Entity(
  "user",
  {
    entity: {
      organizations: [organization],
      workspaces: [workspace],
    },
  },
  {
    idAttribute: "userId",
  },
);

export const tag = new schema.Entity(
  "tag",
  {},
  {
    idAttribute: "id",
  },
);

export const team = new schema.Entity(
  "team",
  { players: [tag] },
  {
    idAttribute: "_id",
  },
);

export const tournament = new schema.Entity(
  "tournament",
  {
    teams: [team],
  },
  {
    idAttribute: "tournamentId",
  },
);

export const stream = new schema.Entity(
  "stream",
  {},
  {
    idAttribute: "_id",
  },
);

export const clip = new schema.Entity(
  "clip",
  { stream: stream },
  {
    idAttribute: "_id",
  },
);

export const clipList = new schema.Entity(
  "clipList",
  {
    clips: [clip],
  },
  {
    idAttribute: "_id",
  },
);

export const webStory = new schema.Entity(
  "webStory",
  {},
  {
    idAttribute: "_id",
  },
);

export const clipListGroupByDate = new schema.Entity(
  "clipListGroupByDate",
  {
    clips: [clipList],
  },
  {
    idAttribute: "_id",
  },
);

const studioProjectClips = new schema.Entity(
  "studioProjectClips",
  {
    clip: clip,
  },
  {
    idAttribute: "id",
    processStrategy: (value) => {
      return {
        id: value.id,
        ...value.clip,
      };
    },
  },
);

export const studioProjectsGroupByDate = new schema.Entity(
  "studioProjectsGroupByDate",
  {
    data: [studioProjectClips],
  },
  {
    idAttribute: "date",
  },
);

export const templates = new schema.Entity(
  "templates",
  {},
  {
    idAttribute: "id",
  },
);

const studioTemplates = new schema.Entity(
  "studioTemplates",
  {
    template: templates,
  },
  {
    idAttribute: "id",
    processStrategy: (value) => {
      return {
        id: value.id,
        ...value.template,
      };
    },
  },
);

export const studioTemplatesGroupByDate = new schema.Entity(
  "studioTemplatesGroupByDate",
  {
    data: [studioTemplates],
  },
  {
    idAttribute: "date",
  },
);

export const channel = new schema.Entity(
  "channel",
  {},
  {
    idAttribute: "id",
  },
);

export const show = new schema.Entity(
  "show",
  {
    channels: [channel],
  },
  {
    idAttribute: "id",
  },
);

export const thumbnailTemplate = new schema.Entity(
  "thumbnailTemplates",
  {},
  {
    idAttribute: "id",
  },
);

export const thumbnailTemplateGroupedByDate = new schema.Entity(
  "thumbnailTemplatesGroupedByDate",
  {
    data: [thumbnailTemplate],
  },
  {
    idAttribute: "date",
  },
);
